import * as styles from './index.css';

const PlaceholderProgressBar = () => (
  <div
    aria-label="Loading progress"
    className={styles.placeholderProgressBarContainer}
    role="progressbar"
  >
    <span className={styles.placeholderProgressBar}></span>
  </div>
);

export default PlaceholderProgressBar;
